import { ReactNode } from 'react';
import { LucideIcon } from 'lucide-react';

interface MetadataFieldProps {
  label: string;
  value: ReactNode;
  icon?: LucideIcon;
  className?: string;
}

/**
 * Reusable component for displaying labeled metadata fields
 * Commonly used in detail views for consistent formatting
 */
export function MetadataField({ label, value, icon: Icon, className = '' }: MetadataFieldProps) {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  return (
    <div className={className}>
      <div className="text-xs font-medium text-foreground-muted uppercase mb-2 flex items-center gap-1">
        {Icon && <Icon className="h-3 w-3" />}
        {label}
      </div>
      <div className="text-sm text-foreground">{value}</div>
    </div>
  );
}
